// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.ColorButton {
    position: relative;
    width: 2em;
    height: 2em;
}

div.colorbutton-icon {
    border-radius: 4px;
    width: 2em;
    height: 2em;
    cursor: pointer;
    background-image: linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%);
    background-size: 12px 12px;
    background-position: 0 0, 0 6px, 6px -6px, -6px 0;
    border: 1px solid var(--border-color);
}

div.colorbutton-icon > span {
    width: calc(2em - 2px);
    height: calc(2em - 2px);
    display: inline-block;
}

div.colorbutton-picker {
    visibility: hidden;
    position: absolute;
    left: -5.5em;
    top: 2.75em;
    background-color: white;
    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);
    border-radius: 0.25em;
    width: 13em;
    z-index: 1;
    padding: 0.25em;
}

div.colorbutton-picker:before {
    content: '';
    display: block;
    position: absolute;
    left: 5.75em;
    top: -0.7em;
    width: 0;
    height: 0;
    border-left: 0.75em solid transparent;
    border-right: 0.75em solid transparent;
    border-bottom: 0.75em solid white;
}

div.colorbutton-picker-icons {
    display: flex;
    flex-wrap: wrap;
}

div.colorbutton-picker-icons > div.colorbutton-icon {
    flex: 0 0 auto;
    margin: 0.25em;
}

div.colorbutton-picker-input {
    margin: 0.25em;
}

div.colorbutton-picker-input > input[type=text] {
    min-width: 0;
    flex: 1 1 5em;
}

div.colorbutton-picker-alpha {
    border-radius: 0 4px 4px 0;
    border: 1px solid var(--border-color);
    height: 2em;
    background-image: linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%);
    background-size: 12px 12px;
    background-position: 0 0, 0 6px, 6px -6px, -6px 0;
    flex: 1 1 5em;
}

div.colorbutton-picker-alpha > div {
    display: flex;
    align-items: center;
    height: calc(2em - 2px);
    background-image: linear-gradient(90deg, rgba(255,255,255,0.5) 0%, white 100%);
}

div.colorbutton-picker-alpha input[type=range] {
    width: 100%;
}

div.colorbutton-picker-spectrum {
    display: flex;
    height: 150px;
    margin: 0 0.25em;
}

div.colorbutton-picker-spectrum > div.react-color-picker__hue-spectrum {
    margin-left: 0.25em!important;
}`, "",{"version":3,"sources":["webpack://./components/widgets/style/ColorButton.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;IACf,0OAA0O;IAC1O,0BAA0B;IAC1B,iDAAiD;IACjD,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,8CAA8C;IAC9C,qBAAqB;IACrB,WAAW;IACX,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,WAAW;IACX,0OAA0O;IAC1O,0BAA0B;IAC1B,iDAAiD;IACjD,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8EAA8E;AAClF;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":["div.ColorButton {\n    position: relative;\n    width: 2em;\n    height: 2em;\n}\n\ndiv.colorbutton-icon {\n    border-radius: 4px;\n    width: 2em;\n    height: 2em;\n    cursor: pointer;\n    background-image: linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%);\n    background-size: 12px 12px;\n    background-position: 0 0, 0 6px, 6px -6px, -6px 0;\n    border: 1px solid var(--border-color);\n}\n\ndiv.colorbutton-icon > span {\n    width: calc(2em - 2px);\n    height: calc(2em - 2px);\n    display: inline-block;\n}\n\ndiv.colorbutton-picker {\n    visibility: hidden;\n    position: absolute;\n    left: -5.5em;\n    top: 2.75em;\n    background-color: white;\n    box-shadow: 0px 0px 5px rgba(136, 136, 136, 1);\n    border-radius: 0.25em;\n    width: 13em;\n    z-index: 1;\n    padding: 0.25em;\n}\n\ndiv.colorbutton-picker:before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: 5.75em;\n    top: -0.7em;\n    width: 0;\n    height: 0;\n    border-left: 0.75em solid transparent;\n    border-right: 0.75em solid transparent;\n    border-bottom: 0.75em solid white;\n}\n\ndiv.colorbutton-picker-icons {\n    display: flex;\n    flex-wrap: wrap;\n}\n\ndiv.colorbutton-picker-icons > div.colorbutton-icon {\n    flex: 0 0 auto;\n    margin: 0.25em;\n}\n\ndiv.colorbutton-picker-input {\n    margin: 0.25em;\n}\n\ndiv.colorbutton-picker-input > input[type=text] {\n    min-width: 0;\n    flex: 1 1 5em;\n}\n\ndiv.colorbutton-picker-alpha {\n    border-radius: 0 4px 4px 0;\n    border: 1px solid var(--border-color);\n    height: 2em;\n    background-image: linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%);\n    background-size: 12px 12px;\n    background-position: 0 0, 0 6px, 6px -6px, -6px 0;\n    flex: 1 1 5em;\n}\n\ndiv.colorbutton-picker-alpha > div {\n    display: flex;\n    align-items: center;\n    height: calc(2em - 2px);\n    background-image: linear-gradient(90deg, rgba(255,255,255,0.5) 0%, white 100%);\n}\n\ndiv.colorbutton-picker-alpha input[type=range] {\n    width: 100%;\n}\n\ndiv.colorbutton-picker-spectrum {\n    display: flex;\n    height: 150px;\n    margin: 0 0.25em;\n}\n\ndiv.colorbutton-picker-spectrum > div.react-color-picker__hue-spectrum {\n    margin-left: 0.25em!important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
